import React, {Fragment, useEffect, useState} from 'react'
import classNames from 'classnames'

export default function LoadingContainer({
    children,
    isLoading,
    status: statusProp,
}) {

    const [ status, setStatus ] = useState(statusProp?.toLowerCase() || 'idle');
    const loading = status === 'loading' || status === 'pending';

    const Classes = classNames({
        'absolute w-full h-full flex items-center justify-center bg-white bg-opacity-80': true,
    })

    useEffect(() => {
        if(statusProp === status) return;
        setStatus(statusProp?.toLowerCase() || 'idle');
        if(statusProp === 'success' || statusProp === 'error') {
            setTimeout(() => {
                setStatus('idle');
            }, 1500);
        }
    }, [statusProp, status]);

    return (
        <Fragment>
            {(isLoading || loading) &&
                <div className={Classes}>
                    <svg className="animate-spin -ml-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-20 stroke-primary" cx="12" cy="12" r="10" strokeWidth="4"></circle>
                        <path className="opacity-100 fill-primary" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                    </svg>
                </div>
            }

            {children}

        </Fragment>
    )
}
